import { getBackendUrl } from "@/lib/backend";
// Curated image assets for Facetra landing
// Primary jewellery imagery is generated by Gemini Nano Banana (via design agent).
// Pexels fallbacks are sparingly used and verified to depict jewellery / craft.
const BACKEND = getBackendUrl();

// Treat anything served from our backend or the Emergent design pipeline
// CDN as a Facetra-generated render (eligible for the watermark badge).
export function isGeneratedRender(url) {
  if (!url) return false;
  return (
    url.includes("/api/images/") ||
    url.includes("static.prod-images.emergentagent.com/jobs/")
  );
}

export const IMG = {
  bgGlow:
    "https://static.prod-images.emergentagent.com/jobs/eeeca02f-d3c5-441b-9386-72486abb936b/images/72f6468863e2c5ef142a343fd3d2852decbc21f0c7a393bf16023eafdc36aab4.png",
  heroSketch:
    "https://static.prod-images.emergentagent.com/jobs/eeeca02f-d3c5-441b-9386-72486abb936b/images/fd1c2449812ac4453783fa0950200484350522f756cec69a6434ea09f048c019.png",
  jadau:
    "https://static.prod-images.emergentagent.com/jobs/eeeca02f-d3c5-441b-9386-72486abb936b/images/9b2edbca310ff5264b2212f55b34085b7340351cdefb57fddfb32f47216092b8.png",
  temple:
    "https://static.prod-images.emergentagent.com/jobs/eeeca02f-d3c5-441b-9386-72486abb936b/images/8fd77b9409386ee0ab1ed75f93368c3ac7daa7f6f5277767d198b4dd7dd5cd38.png",
  meenakari:
    "https://static.prod-images.emergentagent.com/jobs/eeeca02f-d3c5-441b-9386-72486abb936b/images/a6aab9c791668684b16c57d61483c99a9a110c9124aa99519a14ea60c73c0dab.png",
  kundan:
    "https://images.pexels.com/photos/5043048/pexels-photo-5043048.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900",
  avatar1:
    "https://static.prod-images.emergentagent.com/jobs/eeeca02f-d3c5-441b-9386-72486abb936b/images/bf6089b24496628201ce76157eda0d45e7f453e828ee4ed89aabfac650406359.png",
  avatar2:
    "https://static.prod-images.emergentagent.com/jobs/eeeca02f-d3c5-441b-9386-72486abb936b/images/23e954e1e00647e6e1717079d4c61a281bf8860d00491c4c71240a2c81b16de8.png",
  // Backend-generated showcase images (admin Studio Images tab) — verified to match concept.
  polki: `${BACKEND}/api/images/polki_set.png`,
  filigree: `${BACKEND}/api/images/filigree_pendant.png`,
  bridal: `${BACKEND}/api/images/rajwadi_bridal.png`,
  bangle: `${BACKEND}/api/images/gold_bangle.png`,
  choker: `${BACKEND}/api/images/diamond_choker.png`,
  // Pexels / Unsplash fallbacks for remaining concepts
  ring: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?auto=format&fit=crop&w=1200&q=80",
};

export default IMG;
